import { useUrlWithUtmParams } from '@hooks/use-utm-params';
import * as React from 'react';
import styled from 'styled-components';
import slugify from 'slugify';
import GradientButton from '@components/GradientButton';

interface Props {
  children: string;
  sessionId?: string | undefined;
  type?: 'event' | 'speaker';
}

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.9rem auto 0;
`;

const RegisterBtn = ({ children, sessionId, type }: Props): JSX.Element => {
  const url = sessionId
    ? `https://fastly.brandlive.com/dept-of-know-speaker-series/en/session/${sessionId}`
    : 'https://fastly.brandlive.com/dept-of-know-speaker-series/en/registration';
  const urlWithUtmParams = useUrlWithUtmParams(url);
  return (
    <ButtonContainer>
      <GradientButton href={urlWithUtmParams} target="_blank" dataLink={slugify(`${type} link to ${sessionId}`)}>
        {children}
      </GradientButton>
    </ButtonContainer>
  );
};

export default RegisterBtn;
